/* esm.sh - fast-uri@3.0.6 */
export * from "/fast-uri@3.0.6/es2022/fast-uri.mjs";
export { default } from "/fast-uri@3.0.6/es2022/fast-uri.mjs";
